import { motion } from 'motion/react';
import AllCategories from "../assets/allCategories.svg?react"
import { ImageWrapper } from './ImageWrapper.jsx';
import { Breadcrumbs } from './Breadcrumbs.jsx';

export function CategoryFilter({ categories = [], selectedCategory, showAll, breadcrumbs, onCategoryChange, onBreadcrumbClick, position, logActivity, mainCategoryParams = {} }) {
  const mainCategory = { id: 'todos', name: 'Todos', icon: null, image: null, is_visible: false, is_empty: false, deep_level: 0 };
  
  const topModeWidth = 142;
  const topModeHeight = 142;
  const leftModeWidth = 100;
  const leftModeHeight = 100;

  const sortedCategories = Array.isArray(categories) ? [...categories].sort((c1, c2) => {
    const order1 = c1.order ? c1.order : Number.MAX_SAFE_INTEGER;
    const order2 = c2.order ? c2.order : Number.MAX_SAFE_INTEGER;
    return order1 - order2;
  }) : [];

  if (mainCategoryParams.label) mainCategory.label = mainCategoryParams.label;
  if (mainCategoryParams.icon) mainCategory.icon = mainCategoryParams.icon;
  if (mainCategoryParams.image) mainCategory.image = mainCategoryParams.image;
  if (typeof mainCategoryParams.is_visible === 'boolean') mainCategory.is_visible = mainCategoryParams.is_visible;

  const allCategories = showAll ? [mainCategory, ...sortedCategories] : sortedCategories;

  const handleCategoryChange = (categoryId) => {
    const category = allCategories.find(c => c.id === categoryId);
    logActivity('category-slider', 'category-image', 'click', true, {categoryId, categoryName: category ? (category.label || category.name) : null});
    onCategoryChange(categoryId);
  };

  return ( 
    <div
      className={`${position === 'top' ? 'bg-mid-gradient top-24 py-8' : 'h-full w-full'} no-scrollbar`}
      style={{overflowY: 'auto'}}
    >
      <div className="max-w-screen-xl mx-auto">
        {position === 'top' ? (
          <>
            <h2 className="text-center mb-4 px-4 fs-35 lh-36 font-bold main-font-bold">¿Qué vas a pedir hoy?</h2>
            {breadcrumbs && breadcrumbs.length > 0 ? (
              <Breadcrumbs breadcrumbs={breadcrumbs} showBackground={false} categoriesPosition={position} onClick={onBreadcrumbClick} logActivity={logActivity} />
             ) : null}
          </>
        ) : null}
         <div
          className={`flex gap-4 py-4 no-scrollbar ${position === 'top' ? 'overflow-x-auto px-8' : 'flex-col px-5'}`}
          style={{backgroundColor: position == 'top' ? 'var(--cat-background)' : 'unset'}}
        >
          {allCategories.map((category, index) => {
            const isSelected = selectedCategory === category.id;
            return (
              <motion.button
                key={category.id}
                onClick={() => handleCategoryChange(category.id)}
                className='flex flex-col shrink-0 items-center gap-2 cursor-pointer w-auto h-auto'
                whileTap={{ scale: 0.8 }}
                whileHover={{ y: -7 }}
              >
                <div className='relative w-full h-full' style={{width: position === 'top' ? topModeWidth : leftModeWidth, height: position === 'top' ? topModeHeight : leftModeHeight}}>
                  <div className='btn-primary inset-0 rounded-full flex items-center justify-center w-full h-full'>
                    {category.id === 'todos' ? (
                      <div className={`rounded-full object-contain w-full h-full overflow-hidden ${!isSelected ? 'opacity-60' : 'border-solid border-[5px] border-cat'}`}>
                        {category.image || category.icon ? (
                          <ImageWrapper
                            image={category.image || category.icon}
                            alt={category.label || category.name}
                            display="block"
                            width="100%"
                            height="100%"
                            backgroundColor="transparent"
                            margin="0"
                            padding="0"
                            borderRadius="0"
                            transition={true}
                            loadDelay={0.1}
                            onLoad={undefined}
                          />
                        ) : (
                          <AllCategories alt="All Categories" className='w-full h-full'/>
                        )}
                      </div>
                    ) : (
                      category.image || category.icon ? (
                        <div className={`rounded-full object-contain w-full h-full overflow-hidden ${!isSelected ? '' : 'border-solid border-[5px] border-cat'}`}>
                          <ImageWrapper
                            image={category.image || category.icon}
                            alt={category.label || category.name}
                            display="block"
                            width="100%"
                            height="100%"
                            backgroundColor="transparent"
                            margin="0"
                            padding="0"
                            borderRadius="0"
                            transition={true}
                            loadDelay={0.1}
                            onLoad={undefined}
                          />
                        </div>
                      ) : (
                        <div className={`flex items-center p-3 justify-center w-full h-full rounded-full object-contain p-2 ${!isSelected ? 'opacity-60' : 'border-solid border-[5px] border-cat'}`}>
                          {/* SOK-09: el emoji es un ícono dentro de un círculo de tamaño fijo; no crece con "Letra grande". */}
                          {category.emoji ? <p className="text-center whitespace-nowrap" style={{ fontSize: '3rem', lineHeight: 1 }}>{category.emoji}</p> : <p className={`text-lg font-bold text-center overflow-hidden text-ellipsis line-clamp-1`}>{category.label || category.name}</p>}
                        </div>
                      )
                    )}
                  </div>
                </div>
                <p
                  className={`secondary-font-bold text-sm text-center transition-colors duration-200 uppercase tracking-[0.5px] hyphens-auto ${isSelected ? 'secondary-font-bold' : ''} ${position === 'left' && index === allCategories.length - 1 ? 'pb-[150px]' : ''}`}
                  style={{width: position === 'top' ? topModeWidth : leftModeWidth}}
                >{category.label || category.name}</p>
              </motion.button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
